import { ApricotBackground as AuthApricotBackground } from 'components/Generics/Background/ApricotBackground.style';
import { Background as AuthBackground } from 'components/Generics/Background/Background.style';
import { EtoBackground as AuthEtoBackground } from 'components/Generics/Background/EtoBackground.style';
import styled from 'styled-components';

export const Background = AuthBackground;
export const EtoBackground = AuthEtoBackground;
export const ApricotBackground = AuthApricotBackground;
export const Content = styled.div`
    height: 90%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const Footer = styled.div`
    height: 10%;
    width: 100%;
    display: flex;
    flex-direction: column:
    justify-content: center;
    align-items: center;
`;
export const CenteredCard = styled.div`
    min-width: 480px;
    max-width 720px;
    width: 50%;
    min-height: 287px;
    max-height: 431px;
    height: 30%;
    padding: 15px;
    display: flex;
    flex-direction: column;
    flex-wrap: no-wrap;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    @media only screen and (max-width: 479px) {
        width: 100vw;
        box-sizing: border-box;
        min-width: 0;
        height: 52%;
    }
`;

export const ExclamationMark = styled.img`
  width: 100px;
  height: 100px;
  margin-bottom: 15px;
`;

export const ErrorMessage = styled.h4`
    text-align: center;
    color: #013d50;
    font-size: 1.2rem;
    margin-top: 8px;
    margin-bottom: 0px;
`;

export const ErrorDetailsContainer = styled.div`
    min-width: 350px;
    max-width: 400px;
    padding: 10px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const CopyErrorButton = styled.button`
    color: ${({ theme }) => theme?.colors?.mint};
    border: 1px solid ${({ theme }) => theme?.colors?.mint};
    padding: 8px 20px;
    border-radius: 20px;
    cursor: pointer;
    margin-top: 20px;
    font-weight: bold;
`;

export const ShowErrorButton = styled.button`
    background-color: #fff;
    border: 1px solid #ccc;
    min-width: 350px;
    max-width: 400px;
    padding: 5px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
`;

export const ExpandOrCollapseIcon = styled.div`
    path {
        fill: ${({ theme }) => theme?.colors?.mint};
    }
    margin-right: 10px;
`;

export const ErrorMessageContainer = styled.div`
    padding: 0px 10px;
    background-color: #fff;
    border: 1px solid #ccc;
    text-align: left;
    min-height: 50px;
    max-height: 150px;
    overflow-y: auto;
`;

export const CopyErrorContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const ErrorDetailsContent = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
`;

export const PreBlock = styled.pre`
  line-height: 22px;
  letter: normal;
  color: #003D50;
`;

export const ReturntoLogInLink = styled.a`
    color: #309984;;
    text-align: left;
    margin-right: auto;
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    margin-top: 10px;
    font-weight: bold;
    padding: 6px 8px;
    font-size: 0.9rem;

    .icon {
        margin-right: 5px;
    }
`;

export const iconSizes = {
    clipboardCopy: '14px',
    chevronLeft: '14px',
};
